import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { connect } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import images from '../images/images';
import './CannotCancelWhileAbroad.scss';
import { gaEvent } from '../../../../../utilities/analytics/tracking';

import WhatsappIcon from "app/Components/Block/AbroadTroubleshootingWizardBlock/Images/whatsApp.svg";

const CannotCancelWhileAbroad = ({ onClose, whatsAppNumber }) => {
  function handleClose() {
    onClose();
  }

  const handleWhatsAppClick = () => {
    const whatsAppContactLink = `https://wa.me/${window.Config.whatsAppSelfCare}`; // Default number
    if (whatsAppContactLink) {
      window.open(whatsAppContactLink, '_blank');
    }
  };

  return (
    <div className='cannot-cancel-while-abroad-pop-up-container'>
      <div className='content'>
        <div className='content-frame'>
          <Image src={require('../images/cancelAbroad.svg')} style={{width: '120px', height: '120px'}} />
          <div className='title'>שימו לב</div>
          <div className='description'>בהגעתך לחו''ל כבר לא ניתן לבטל <br/> את החבילה שרכשת</div>
        </div>
      </div>
      <div className='contact-us'>
        <div className='contact-us-title'>אנחנו זמינים לכל שאלה</div>
        <button
          type='button'
          className='whatsapp-button'
          onClick={handleWhatsAppClick}
        >
          <Image src={WhatsappIcon} alt="WhatsApp" className={'whatsapp-icon'} />
          &nbsp;לנציג ב-WhatsApp
        </button>
      </div>
      <BtnSubmit className='got-button' onclick={() => handleClose()} text={`הבנתי`} />
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CannotCancelWhileAbroad);
